import React from 'react'
import { Link } from 'react-router-dom'

class CountryAdd extends React.Component {
  state = {
    status: 'AVAILABLE',
    description: '',
    ctryName: '',
    ctryNameAr: '',
    contID: '',
    currency: '',
    code: '',
    continent_data: [],
    country_id: '',
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  updateCountryData = () => {}

  addCountry = () => {}
  onHandleDescriptionChange = (value) => {
    this.setState({ description: value })
  }
  onSaveData = () => {}
  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Select Continent</label>
                <div className="col-sm-9">
                  <select
                    name="contID"
                    className="form-control form-control-inverse"
                    onChange={this.handleChange}
                    value={this.state.contID}
                  >
                    <option value="">Select Continent</option>
                    {this.state.continent_data !== undefined &&
                    this.state.continent_data !== null &&
                    this.state.continent_data !== [] &&
                    this.state.continent_data.length > 0
                      ? this.state.continent_data.map((continent_data, i) => (
                          <option
                            value={continent_data.contID}
                            key={i}
                          >
                            {continent_data.contName}
                          </option>
                        ))
                      : null}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Country Name</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="ctryName"
                    id="ctryName"
                    placeholder="Country Name"
                    onChange={this.handleChange}
                    value={this.state.ctryName}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Country Name Ar</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="ctryNameAr"
                    id="ctryNameAr"
                    placeholder="Country Name Ar"
                    onChange={this.handleChange}
                    value={this.state.ctryNameAr}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Currency</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="currency"
                    id="currency"
                    placeholder="Currency"
                    onChange={this.handleChange}
                    value={this.state.currency}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Country Code</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="code"
                    id="code"
                    placeholder="Country Code"
                    onChange={this.handleChange}
                    value={this.state.code}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Status</label>
                <div className="col-sm-9">
                  <select
                    name="status"
                    className="form-control"
                    value={this.state.status}
                    onChange={this.handleChange}
                  >
                    <option
                      value="AVAILABLE"
                      name="AVAILABLE"
                    >
                      AVAILABLE
                    </option>
                    <option
                      value="NOT_AVAILABLE"
                      name="NOT_AVAILABLE"
                    >
                      NOT AVAILABLE
                    </option>
                    <option
                      value="BUSY"
                      name="BUSY"
                    >
                      BUSY
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row">
            <div className="col-md-12">
              <div className="form-group row">
                <label className="col-sm-2 col-form-label">Description</label>
                <div className="col-sm-10">
                  <ReactQuill
                    value={this.state.description}
                    onChange={this.onHandleDescriptionChange}
                    style={{ height: "200px", marginBottom: '5%' }}
                  />
                </div>
              </div>
            </div>
          </div> */}

          <div className="card-footer">
            <div className="row">
              <div className="text-right col-6 offset-6">
                <Link
                  to="/country"
                  className="btn btn-outline-secondary"
                >
                  <i className="icofont icofont-rounded-double-left"></i>
                  Back
                </Link>
                {this.state.isSaving ? (
                  <button
                    className="btn hor-grd btn-grd-inverse offset-1"
                    disabled
                  >
                    Saving...!
                  </button>
                ) : (
                  <button
                    onClick={this.onSaveData}
                    className="btn hor-grd btn-grd-inverse offset-1"
                  >
                    <i className="ti-save"></i>Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CountryAdd
